var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F3F3F9",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 25.5C13.3749 25.5 12.9826 25.3368 12.6562 25.0104C12.3298 24.684 12.1666 24.2917 12.1666 23.8333V13H11.3333V11.3333H15.4999V10.5H20.4999V11.3333H24.6666V13H23.8333V23.8333C23.8333 24.2917 23.6701 24.684 23.3437 25.0104C23.0173 25.3368 22.6249 25.5 22.1666 25.5H13.8333ZM22.1666 13H13.8333V23.8333H22.1666V13ZM15.4999 22.1667H17.1666V14.6667H15.4999V22.1667ZM18.8333 22.1667H20.4999V14.6667H18.8333V22.1667Z",
    fill: "#FF3737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0fa2ce42ee19c68d1c3ec1f08ed2125f.svg";
export { ForwardRef as ReactComponent };